import React, { Component } from "react";
export class ListItems extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { first_name, last_name, thumb, position_, bio} = this.props;
    // console.log("list:", this.props);
    return (
      <div className="item">
        {thumb?<img src={thumb[0].thumbnails.large.url} alt={`${first_name} ${last_name}, ${position_}`} />:""}
        <h3>{first_name} {last_name}</h3>
        <h4>{position_}</h4>
        <p>{bio}</p>
      </div>
    );
  }
}
export default ListItems;
